import { createSlice } from '@reduxjs/toolkit';

import { handleSearchSupplements } from './actions';
import { ISupplementSearchState } from './slice.interface';

const initialState: ISupplementSearchState = {
  data: null,
  isLoading: false,
};

export const supplementSearchSlice = createSlice({
  name: 'supplement-search',
  initialState,
  reducers: {
    removeDietarySupplementSearch: state => {
      state.data = null;
      state.isLoading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(handleSearchSupplements.pending, (state: ISupplementSearchState) => {
        state.isLoading = true;
      })
      .addCase(handleSearchSupplements.fulfilled, (state: ISupplementSearchState, action) => {
        const { page, pageCount } = action.payload.data.pagination;

        if (pageCount === 1 || page === 1) {
          state.data = action.payload.data;
        } else {
          state.data = {
            ...action.payload.data,
            tableData: [...(state.data?.tableData ?? []), ...action.payload.data.tableData],
          };
        }

        state.isLoading = false;
      });
  },
});

export const { removeDietarySupplementSearch } = supplementSearchSlice.actions;

export default supplementSearchSlice.reducer;
